<template>
  <v-dialog v-model="dialog" persistent :width="width">
    <v-card>
      <v-card-title>
        <span v-if="!hideTitle">{{ title }}</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="auto">
            <v-icon v-if="!hideIcon" :color="iconColor" x-large>
              {{ icon }}
            </v-icon>
          </v-col>
          <v-col>
            <span style="white-space: pre-wrap">{{ message }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="px-4 mb-2" elevation="2" @click="setNextStep(false)"> いいえ </v-btn>
        <v-btn color="primary" class="px-4 mb-2" elevation="2" @click="setNextStep(true)"> はい </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "Confirm.vue",
  props: {
    message: {
      type: String,
      require: true
    },
    title: {
      type: String,
      default: "確認"
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    hideIcon: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: "mdi-alert-outline"
    },
    iconColor: {
      type: String,
      default: "error"
    },
    width: {
      type: String,
      default: "500px"
    }
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    /**
     * ダイアログを開く
     */
    open() {
      this.dialog = true;
    },
    /**
     * ボタンのクリック
     */
    setNextStep(btnFlag) {
      this.dialog = false;
      this.$emit("setStep", btnFlag);
    }
  }
};
</script>
